module.exports = __webpack_public_path__ + "img/bvb-fanabteilung-logo2x.934bd91f.png";